import type { InferInsertModel, InferSelectModel } from 'drizzle-orm';
import { boolean, pgTable, text, timestamp, uuid } from 'drizzle-orm/pg-core';

export const shirtSizes = pgTable('shirt_sizes', {
  id: uuid('id')
    .primaryKey()
    .$defaultFn(() => Bun.randomUUIDv7()),
  description: text('description').notNull(),
  isActive: boolean('is_active').default(true),
  createdAt: timestamp('created_at')
    .notNull()
    .$defaultFn(() => new Date()),
  updatedAt: timestamp('updated_at')
    .$onUpdate(() => new Date())
    .notNull(),
});

export type ShirtSize = InferSelectModel<typeof shirtSizes>;
export type CreateShirtSizeInput = InferInsertModel<typeof shirtSizes>;
export type UpdateShirtSizeInput = Partial<CreateShirtSizeInput>;
